import { ProjectGqPropsLimited } from './../models/ProjectGq';
import gql from 'graphql-tag';
import { useCustomQuery } from '../../../logic/api/graphQL/useCustomQuery';
import { ProjectGq } from '../models/ProjectGq';
import { ProjectTypeGq } from '../models/ProjectTypeGq';
import { QueryHookOptions } from '@apollo/client';

export function useGetProjectsGq(
  command: CommandGq,
  options?: QueryHookOptions<GQLData, GQLVariables>
) {
  const query = useCustomQuery<GQLData, GQLVariables>(gqTag, {
    variables: { command: command },
    ...options,
  });

  return {
    query,
    data: (query?.data ?? query?.previousData)?.projects?.getProjects,
  };
}

const gqTag = gql`
  query GetProjects($command: GetProjectsCommand!) {
    projects {
      getProjects(command: $command) {
        projects {${ProjectGqPropsLimited}}
        page
        totalCount
        amountPerPage
        sortDirection
        sortBy
      }
    }
  }
`;



interface GQLData {
  readonly projects: {
    readonly getProjects: GetProjectsResponseGq;
  };
}

export interface GetProjectsResponseGq {
  readonly projects: ProjectGq[];
  readonly page: number;
  readonly totalCount: number;
  readonly amountPerPage: number;
  readonly sortBy?: string;
  readonly sortDirection?: 'asc' | 'desc';
}

interface GQLVariables {
  command: CommandGq;
}

export interface CommandGq {
  ids?: number[];
  excludeIds?: number[];
  type?: ProjectTypeGq;
  types?: ProjectTypeGq[];
  page?: number;
  amountPerPage?: number;
  searchTerm?: string;
  userOnly?: boolean;
  showArchived?: boolean;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
  currentProjectId?: number;
  progressEnabled?: boolean;
  locOrLangFilter?: boolean;
  locationId?: number;
  languageId?: number;
}

export interface GetProjectsCommandGq extends CommandGq { }